const salesTaskMixins = {
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 18
        }
      },
      merchantId: '',
      platformId: ''
    }
  },
  created() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    const list = [
      { name: 'MarketingTask', title: '营销任务' },
      { name: 'DailyAttendanceStatistics', title: '打卡任务' },
      { name: 'WithdrawalSettings', title: '提现设置' }
    ]
    this.$store.commit('SET_MENU_HEAD_CONFIG', list)
  },
  methods: {
    getPopupContainer(trigger) {
      return trigger.parentElement
    }
  }
}
export default salesTaskMixins